import { LuLayoutDashboard, LuUsers, LuBookUser, LuShieldCheck, LuWallet, LuBot, LuBookOpen, LuMessageSquare, LuChartColumn, LuPhone, LuServer, LuHistory, LuBellRing } from 'react-icons/lu'
import { ROLES, ADMIN_ROLES } from 'utils/roles'

/**
 * Menú lateral agrupado por secciones.
 *
 * - requiredModules (sección o ítem): el usuario debe tener AL MENOS UNO de
 *   esos módulos. Así un cliente solo de chatbot no ve "Centralita" y al revés.
 * - requiredPermissions (sección o ítem): roles que lo ven (1 admin, 2 editor,
 *   4 superadmin; ver utils/roles.js),
 *   3 viewer). null = todos.
 * - title: sección sin título = va arriba del todo, sin cabecera.
 */
const iconProps = { size: 18, strokeWidth: 1.75, 'aria-hidden': true }

export const menuSections = [
  {
    title: null,
    items: [
      { title: 'layout:menu.dashboard', slug: '/', icon: <LuLayoutDashboard {...iconProps} /> },
    ],
  },
  {
    title: 'layout:sections.chatbot',
    requiredModules: ['chatbot'],
    items: [
      { title: 'layout:menu.assistants', slug: '/assistants', icon: <LuBot {...iconProps} /> },
      { title: 'layout:menu.vectorstores', slug: '/vectorstores', requiredPermissions: [ROLES.ADMIN, ROLES.EDITOR, ROLES.SUPERADMIN], icon: <LuBookOpen {...iconProps} /> },
      { title: 'layout:menu.conversations', slug: '/conversations', icon: <LuMessageSquare {...iconProps} /> },
      { title: 'layout:menu.statistics', slug: '/statistics', icon: <LuChartColumn {...iconProps} /> },
    ],
  },
  {
    title: 'layout:sections.centralita',
    requiredModules: ['centralita'],
    items: [
      { title: 'layout:menu.calls', slug: '/centralita', icon: <LuPhone {...iconProps} /> },
      { title: 'layout:menu.contacts', slug: '/contactos', icon: <LuBookUser {...iconProps} /> },
    ],
  },
  {
    // Solo editores: gestionan los viewers de su proyecto. El admin gestiona
    // usuarios (y empresas y proyectos) desde Gestinet → Administración.
    title: 'layout:sections.team',
    requiredPermissions: [2],
    items: [
      { title: 'layout:menu.users', slug: '/users/grid', icon: <LuUsers {...iconProps} /> },
    ],
  },
  {
    // Solo Admin y Superadmin (Gestinet): expone el gasto de todas las empresas
    title: 'layout:sections.admin',
    requiredPermissions: ADMIN_ROLES,
    items: [
      { title: 'layout:menu.costs', slug: '/costes', icon: <LuWallet {...iconProps} /> },
      // Avisos e informe mensual que se envían por correo (vía n8n)
      { title: 'layout:menu.notifications', slug: '/avisos', icon: <LuBellRing {...iconProps} /> },
      // Servidores: solo Superadmin (permite reiniciar producción)
      { title: 'layout:menu.servers', slug: '/servidores', requiredPermissions: [ROLES.SUPERADMIN], icon: <LuServer {...iconProps} /> },
      // Registro de actividad: solo Superadmin (ve lo que hacen los demás admins)
      { title: 'layout:menu.activity', slug: '/actividad', requiredPermissions: [ROLES.SUPERADMIN], icon: <LuHistory {...iconProps} /> },
      { title: 'layout:menu.admin', slug: '/admin', icon: <LuShieldCheck {...iconProps} /> },
    ],
  },
]

// Lista plana (para buscar el título de la página actual, etc.)
export const menuItems = menuSections.flatMap(section =>
  section.items.map(item => ({
    ...item,
    requiredModules: item.requiredModules || section.requiredModules || null,
    requiredPermissions: item.requiredPermissions || section.requiredPermissions || null,
  }))
)
